/**
 * Beeltra Reviews -- first-party customer reviews only (Phase R2,
 * 2026-09-10). Never Judge.me, never AliExpress/supplier reviews,
 * never generated content.
 *
 * Fetches GET /api/reviews/product?productId=<numeric Shopify id> from
 * the Beeltra Reviews Worker API (published reviews + a summary
 * computed server-side, never a number this file invents). Renders
 * nothing fabricated: if reviewCount is 0, the whole section stays
 * hidden (or shows the neutral empty-state text, per
 * data-show-empty-state) -- never fake/empty stars pretending there is
 * activity.
 */
(function () {
  "use strict";

  var API_BASE = "https://beeltra-supplier-api.deliverypro.workers.dev";

  function starsMarkup(rating) {
    var pct = Math.max(0, Math.min(100, (Number(rating) || 0) / 5 * 100));
    return (
      '<span class="beeltra-star-rating beeltra-star-rating--overlay" aria-hidden="true">' +
      '<span class="beeltra-star-rating__bg">★★★★★</span>' +
      '<span class="beeltra-star-rating__fg" style="width:' + pct + '%">★★★★★</span>' +
      "</span>"
    );
  }

  // Explicit escaping (never a DOM round-trip) -- safe for BOTH plain
  // text-node content and quoted-attribute-value contexts, since every
  // untrusted field this file renders (review title/body/reviewer name)
  // is real customer-submitted text, even though it was already
  // HTML-stripped server-side before storage (defense in depth, not the
  // only layer).
  function escapeHtml(text) {
    return String(text == null ? "" : text)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function formatDate(iso) {
    if (!iso) return "";
    try {
      return new Date(iso).toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" });
    } catch (e) {
      return "";
    }
  }

  function renderSummary(summary) {
    var distRows = ["5", "4", "3", "2", "1"]
      .map(function (star) {
        var count = summary.distribution && summary.distribution[star] ? summary.distribution[star] : 0;
        var pct = summary.reviewCount > 0 ? Math.round((count / summary.reviewCount) * 100) : 0;
        return (
          '<div class="beeltra-reviews__dist-row">' +
          '<span class="beeltra-reviews__dist-label">' + star + "★</span>" +
          '<span class="beeltra-reviews__dist-track"><span class="beeltra-reviews__dist-bar" style="width:' + pct + '%"></span></span>' +
          '<span class="beeltra-reviews__dist-count">' + count + "</span>" +
          "</div>"
        );
      })
      .join("");

    return (
      '<div class="beeltra-reviews__summary">' +
      '<div class="beeltra-reviews__average">' +
      '<span class="beeltra-reviews__average-number">' + summary.averageRating + "</span>" +
      starsMarkup(summary.averageRating) +
      '<span class="beeltra-reviews__count">' + summary.reviewCount + " " + (summary.reviewCount === 1 ? "review" : "reviews") + "</span>" +
      "</div>" +
      '<div class="beeltra-reviews__distribution">' + distRows + "</div>" +
      "</div>"
    );
  }

  function renderCard(review) {
    var imagesHtml = "";
    if (review.images && review.images.length) {
      imagesHtml =
        '<div class="beeltra-reviews__card-images">' +
        review.images
          .map(function (src) {
            return '<img src="' + escapeHtml(src) + '" alt="" loading="lazy" width="72" height="72">';
          })
          .join("") +
        "</div>";
    }

    var badgeHtml = "";
    if (review.verifiedBeeltraPurchase === true) {
      badgeHtml = '<span class="beeltra-reviews__badge beeltra-reviews__badge--verified">Verified Beeltra purchase</span>';
    }

    return (
      '<li class="beeltra-reviews__card">' +
      '<div class="beeltra-reviews__card-head">' +
      starsMarkup(review.rating) +
      (review.createdAt ? '<time class="beeltra-reviews__date">' + escapeHtml(formatDate(review.createdAt)) + "</time>" : "") +
      "</div>" +
      (review.title ? '<p class="beeltra-reviews__card-title">' + escapeHtml(review.title) + "</p>" : "") +
      '<p class="beeltra-reviews__card-body">' + escapeHtml(review.body) + "</p>" +
      imagesHtml +
      '<div class="beeltra-reviews__card-meta">' +
      '<span class="beeltra-reviews__reviewer">' + escapeHtml(review.reviewerDisplayName || "Beeltra customer") + "</span>" +
      badgeHtml +
      "</div>" +
      "</li>"
    );
  }

  function render(container, data) {
    var heading = container.getAttribute("data-heading") || "Reviews";
    var showEmptyState = container.getAttribute("data-show-empty-state") === "true";
    var emptyStateText = container.getAttribute("data-empty-state-text") || "No reviews yet.";

    if (!data || !data.summary || data.summary.reviewCount === 0) {
      if (!showEmptyState) {
        container.hidden = true;
        container.innerHTML = "";
        return;
      }
      container.hidden = false;
      container.innerHTML =
        '<h2 class="beeltra-reviews__heading h3">' + escapeHtml(heading) + "</h2>" +
        '<p class="beeltra-reviews__empty">' + escapeHtml(emptyStateText) + "</p>";
      return;
    }

    container.hidden = false;
    container.innerHTML =
      '<h2 class="beeltra-reviews__heading h3">' + escapeHtml(heading) + "</h2>" +
      renderSummary(data.summary) +
      '<ul class="beeltra-reviews__list" role="list">' +
      data.publishedReviews.map(renderCard).join("") +
      "</ul>";
  }

  document.addEventListener("DOMContentLoaded", function () {
    var container = document.querySelector("[data-beeltra-reviews]");
    if (!container) return;
    var productId = container.getAttribute("data-product-id");
    if (!productId) return;

    fetch(API_BASE + "/api/reviews/product?productId=" + encodeURIComponent(productId))
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (data) {
        render(container, data && data.success ? data : null);
      })
      .catch(function () {
        // Network/API failure -- never show fake content, just leave
        // the section hidden (same as zero real reviews).
        render(container, null);
      });
  });
})();
